import { useEffect } from "react";

export default function Drawer({ open, onClose, title, children, footer, width = "440px" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <div
      className={`fixed inset-0 z-50 transition-opacity ${
        open ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      {/* mobile: bottom sheet sliding up; tablet+: right-side drawer sliding in */}
      <div
        style={{ width: `min(100%, ${width})` }}
        className={`absolute inset-x-0 bottom-0 h-[92%] rounded-t-2xl
          tablet:inset-x-auto tablet:right-0 tablet:top-0 tablet:bottom-auto tablet:h-full
          tablet:rounded-t-none tablet:rounded-l-2xl
          bg-white shadow-xl flex flex-col transition-transform duration-300
          ${open ? "translate-y-0 tablet:translate-x-0" : "translate-y-full tablet:translate-y-0 tablet:translate-x-full"}`}
      >
        {/* drag handle — mobile sheet affordance only */}
        <div className="flex justify-center pt-2 pb-1 shrink-0 tablet:hidden">
          <span className="w-9 h-1 rounded-full bg-[#D1D1D1]" />
        </div>
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 shrink-0">
          <h2 className="text-base font-semibold text-[#21272A]">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl leading-none">
            &times;
          </button>
        </div>
        <div className="p-5 overflow-y-auto flex-1">{children}</div>
        {footer && <div className="px-5 py-4 border-t border-gray-100 shrink-0">{footer}</div>}
      </div>
    </div>
  );
}
